import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { } from "../../store/actions"

import { Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"
import SidebarContent from "./SidebarContent"
import MySnow from '../../components/ui/snow';
import logo from "../../assets/images/logo.png"
import logoHat from "../../assets/animation/logo-hat.png"
import logoSock from "../../assets/animation/logo-sock.png"
import logoLantern from "../../assets/animation/logo-lantern.png"

class Sidebar extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    return (
      <React.Fragment>
        <div className="vertical-menu">
          {/* <MySnow snowflakeCount={30} radius={[5.0, 16.0]}/> */}
          <div className="navbar-brand-box">
            {/* <MySnow snowflakeCount={5} radius={[5.0, 16.0]}/> */}
            <Link to="/" className="logo logo-light pt-4">
              {/* <img src={logoHat} alt="" className="chr-hat" height="32" /> */}
              <span className="logo-sm ">
                <img src={logo} alt="" height="32" />
              </span>
              <span className="logo-lg">
                <img src={logo} alt="" height="80" />
              </span>
              <img src={logoLantern} alt="" className="chr-sock" height="32" />
            </Link>
          </div>
          <div data-simplebar className="h-100 mt-5">
            {this.props.type !== "condensed" ? (
              <SidebarContent profileData={this.props.profileData} />
            ) : (
              <SidebarContent />
            )}
          </div>
          <div className="sidebar-background"></div>
        </div>
      </React.Fragment>
    )
  }
}

Sidebar.propTypes = {
  type: PropTypes.string,
}

const mapStateToProps = state => {
  return {
    layout: state.Layout,
  }
}
export default connect(
  mapStateToProps,
  {}
)(withRouter(withTranslation()(Sidebar)))
